import { MediaFileThumbnailProps } from './Types'
import { VideoThumbnail } from './VideoThumbnail'
import { ImageThumbnail } from './ImageThumbnail'
import { isVideo } from 'components/ImagePickerModal/utils'

export const MediaFileThumbnail = ({ mediaFile, ...props }: MediaFileThumbnailProps) => {
  const url = mediaFile.url || mediaFile.source_url
  const isVideoType = isVideo({ url: url, type: mediaFile.mime_type })

  if (isVideoType) {
    return <VideoThumbnail video={mediaFile} {...props} key={url} />
  }

  return <ImageThumbnail image={mediaFile} {...props} key={url} />
}
